<template>
<div class="chapter">
<div class="inner_page">
<div class="title" id="tit01"><a id="page03">
<h2 class="titlePageTitle">24™ Declassified
Storm Force</h2>
<h2 class="titlePageAuthor">David Jacobs</h2>
<p class="titlePageText">Based on the hit FOX series created by Joel Surnow &amp; Robert Cochran</p>
<p class="titlePageLogo"><img alt="" src="logo.jpg"/></p>
</a></div><a id="page03">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780061734106_title.vue?947f310c